const taskListApi = '/app/item/taskList'

const type = [
    {
        label: '代办理',
        filter: {
            status: 0,
        },
    },
    {
        label: '已完成',
        filter: {
            status: 1,
        },
    },
]

const { getStatusText } = require('./todo')
const { todoType } = require('./todoType')

function getTypeText(typeVal) {
    const todoItem = todoType.find((t) => t.value && t.value.toString() === typeVal.toString())
    return todoItem ? todoItem.label : ''
}

const mixin = {
    methods: {
        mappingData(arr) {
            return arr
        },
    },
}

module.exports = {
    type,
    taskListApi,
    mixin,
    getStatusText,
    getTypeText,
}
